<template>
  <div v-if="initialized" class="mandatory-comment">
    <h2>{{ tStatic('mandatoryCommentRequired') }}</h2>
    <oie-base-input
      v-for="comment in clientModel.mandatoryComment"
      :id="comment.key"
      :key="comment.key"
      v-model="state.mandatoryComments[comment.key].value"
      :label-text="comment.title"></oie-base-input>
  </div>
</template>

<script>
import { state } from '@/store/mandatory-comments'
export default {
  data() {
    return {
      state,
      initialized: false
    }
  },
  beforeMount() {
    if(this.clientModel.mandatoryComment) {
      this.clientModel.mandatoryComment.forEach(comment => {
        this.state.mandatoryComments[comment.key] = comment
      })
      this.initialized = true
    }
  }
}
</script>

<style lang="scss">
.mandatory-comment {
  display: flex;
  flex-direction: column;
  gap: measure(quarter);
  background-color: color(background-yellow);
  border: 1px solid color(border-yellow);
  padding: measure(quarter) measure(half);

  @include media(medium) {
    padding: measure(half) measure(full);
  }
}

.mandatory-comment h2 {
  @include body-bold;
}
</style>
